module.exports = __webpack_public_path__ + "static/media/8.da2c96d8.jpg";